export default  {
  //   dev:{
  //       host:"http://admin.omtyj.com/api",
		// imgHost:"http://img.omtyj.com/product/",
		// webHost:"http://www.omtyj.com",
  //   },
    pro:{
        host:"https://sytadmin.cosonsen.net/api",
		imgHost:"https://img.cosonsen.net/product/",
		webHost:"https://www.cosonsen.net",
    }

}


